import { useMemo } from 'react';
import { getTasklistsToSubmit, getTasklistToSubmitByFilters } from '../utils';
import { useAppSelector } from '../../../../hooks/useAppStore';
import { getDailySubmissions, getSelectedTasklistToSubmit, getTasklists } from '../../../../store/tasklists/selectors';
import { getAuthenticateUser } from '../../../../store/authenticate/selectors';

export function useSharedTasklists() {
  const tasklists = useAppSelector(getTasklists);
  const dailySubmissions = useAppSelector(getDailySubmissions);
  const selectedTasklistToSubmit = useAppSelector(getSelectedTasklistToSubmit);
  const { personnel } = useAppSelector(getAuthenticateUser);

  const tasklistsToSubmit = useMemo(() => {
    const localTasklistsToSubmit = getTasklistsToSubmit(tasklists, dailySubmissions);

    return getTasklistToSubmitByFilters(localTasklistsToSubmit, personnel);
  }, [tasklists, selectedTasklistToSubmit]);

  return {
    tasklistsToSubmit,
  };
}
